import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import './horizontalNavBar.css'
import Modal from '../../Modal/Modal'

const HorizontalNavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [isContactOpen, setIsContactOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 920) {
        setIsMenuOpen(false)
      }
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev)
  }

  const handleLinkClick = () => {
    setIsMenuOpen(false)
  }

  const handleContactClick = (event) => {
    event.preventDefault()
    handleLinkClick()
    setIsContactOpen(true)
  }

  const closeContactModal = () => setIsContactOpen(false)

  const navbarClassNames = [
    'navbar',
    isMenuOpen ? 'navbar--open' : '',
    isScrolled ? 'navbar--scrolled' : ''
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <nav className={navbarClassNames} id="navbar">
      <div className="container">
        <a href="/" class="logoLink">
          <div className="logo">
            <span className="logo__mark" aria-hidden="true">
              ◈
            </span>
            ARCHMIPLAN
          </div>
        </a>
        <button
          type="button"
          className={`navbar-toggle ${isMenuOpen ? 'is-active' : ''}`}
          onClick={handleToggle}
          aria-label="Переключить меню"
          aria-expanded={isMenuOpen}
          aria-controls="navbar-links"
        >
          <span />
          <span />
          <span />
        </button>
        <ul
          className={`nav-links ${isMenuOpen ? 'nav-links--open' : ''}`}
          id="navbar-links"
        >
          <li>
            <NavLink to="/" onClick={handleLinkClick}>
              Главная
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" onClick={handleLinkClick}>
              Проекты
            </NavLink>
          </li>
          <li>
            <NavLink to="/news" onClick={handleLinkClick}>
              Новости
            </NavLink>
          </li>
          <li className="nav-links__cta">
            <NavLink to="/#contacts" onClick={handleContactClick}>
              Связаться
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="navbar__accent" aria-hidden="true" />
      <Modal isOpen={isContactOpen} onClose={closeContactModal} title="Контакты" size="sm">
        <div className="contact-modal">
          <div>
            <span className="contact-modal__label">Адрес</span>
            <p className="contact-modal__value">ул. Магомета Гаджиева, 73А</p>
          </div>
          <div>
            <span className="contact-modal__label">Телефон</span>
            <p className="contact-modal__value">
              <a href="tel:+79882069639">+7 988 206-96-39</a>
            </p>
          </div>
          <div>
            <span className="contact-modal__label">Email</span>
            <p className="contact-modal__value">
              <a href="mailto:archmiplan@gmail.com">archmiplan@gmail.com</a>
            </p>
          </div>
        </div>
      </Modal>
    </nav>
  )
}

export default HorizontalNavBar